/*
 * See the file LICENSE for the full license governing this code.
 */

import * as React from 'react';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import Tooltip from '@mui/material/Tooltip';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Logout from '@mui/icons-material/Logout';
import { Link } from 'react-router-dom';
import { useAuth } from '../authentication';

const avatarIconSize = { width: 32, height: 32 };

export default function UserManagement() {
  const auth = useAuth();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Tooltip title="Account settings">
        <IconButton data-cy="user-menu" onClick={handleClick} size="small">
          <Avatar sx={avatarIconSize} />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          sx: {
            '& .MuiAvatar-root': {
              ...avatarIconSize,
              ml: -0.5,
              mr: 1,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem component={Link} to="/user">
          <Avatar /> {auth.username}
        </MenuItem>
        <Divider />
        {process.env.REACT_APP_PUBLISHABLE_KEY ? (
          <MenuItem component={Link} to="/upgrade-user">
            UPGRADE USER PLACEHOLDER
          </MenuItem>
        ) : null}
        <MenuItem
          onClick={async () => {
            try {
              await auth.signout();
            } catch (err) {
              // TODO: figure out the expected error handling here
              console.error(err);
            }
          }}
        >
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Logout
        </MenuItem>
      </Menu>
    </>
  );
}
